import { useTranslation } from 'react-i18next';

const palette = [
  { color: '#fcdf86', label: 'studio', id: 'studio' },
  { color: '#5b5454', label: 'one_bedroom_short', id: '1pn' },
  { color: '#d7552c', label: 'one_bedroom_plus_short', id: '1pn-plus' },
  { color: '#b8943d', label: 'two_bedroom_short', id: '2pn-1wc' },
  { color: '#99d2c9', label: 'two_bedroom_plus_short', id: '2pn-2wc' },
  { color: '#f9bd9c', label: 'three_bedroom_short', id: '3pn' },
  { color: '#d0072e', label: 'three_bedroom_dualkey_short', id: '3pn-dualkey' },
];

export const FloorPalette = () => {
  const { t } = useTranslation();
  return (
    <div className="floor-palette">
      <div className="palette-container">
        {palette.map((item) => (
          <div className="palette-item" key={item.id}>
            <div
              className="color-box"
              style={{ backgroundColor: item.color }}
            ></div>
            <span className="label">{t(item.label)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
